import { useState } from "react";

function getInitials(name?: string) {
  if (!name) return "?";
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

export function CompanyAvatar({
  logoUrl,
  name,
  size = "md",
}: {
  logoUrl?: string;
  name?: string;
  size?: "md" | "lg";
}) {
  const dims = size === "lg" ? "h-12 w-12 text-base" : "h-10 w-10 text-sm";
  const [errored, setErrored] = useState(false);
  if (logoUrl && !errored) {
    return (
      <img
        src={logoUrl}
        alt={name ?? "Company logo"}
        className={`${dims} shrink-0 rounded-lg border border-border bg-card object-contain`}
        onError={() => setErrored(true)}
      />
    );
  }
  return (
    <div
      className={`${dims} shrink-0 flex items-center justify-center rounded-lg bg-foreground text-background font-semibold`}
    >
      {getInitials(name)}
    </div>
  );
}
